import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Wrapper, PageTitle, TourGrid } from './Tour.styles';
import Page from '../../components/Page/Page';

import { tours } from '../../constants/tours';

const Tour = () => {
  const location = useLocation();

  return (
    <Page background={false}>
      <Wrapper>
        <PageTitle>Rundgang Hausboote</PageTitle>
        <TourGrid>
          {tours &&
            tours.map((item) => (
              <Link key={item.id} to={`${location.pathname}/${item.id}`}>
                <img src={item.img} alt={item.title} />
                <div>
                  <span>{item.title}</span>
                </div>
              </Link>
            ))}
        </TourGrid>
      </Wrapper>
    </Page>
  );
};

export default Tour;
